import { BaseError } from './base';

export class NoNetworkProvidersError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'no_network_providers',
      docsUrl: null,
      name: 'NoNetworkProvidersError',
      shortMessage: 'No networks were registered in the client',
    });
  }
}
